import { useMediaQuery } from "@uidotdev/usehooks";
import * as React from "react";

interface IsoContext {
  isLarge: boolean;
}

const isoContext = React.createContext<IsoContext>({} as any);

export function useIsoContext() {
  return React.useContext(isoContext);
}

interface Props {
  children?: React.ReactNode;
}

export function IsoProvider({ children }: Props) {
  const isLarge = useMediaQuery("only screen and (min-width: 768px)");

  return <isoContext.Provider value={{ isLarge }}>{children}</isoContext.Provider>;
}
